module.exports = __webpack_public_path__ + "media/src/images/logo/logo-1-f719e88aa7896c2a8999eb996e9708b3.png";